import { queryInstructList, addBriefnessInstruct, addComplexInstruct, reTry, cancel, queryByType, exportTerminalId } from "../../api/config/modules/EquipmentControl";

const state = { queryInstructList: {}, addBriefnessInstruct: {}, addComplexInstruct: {}, reTry: {}, cancel: {}, queryByType: {}, exportTerminalId: {} };

const mutations = {
    SET_QUERYINSTRUCTLIST: (state, queryInstructList) => { state.queryInstructList = queryInstructList },
    SET_ADDBRIEFNESSINSTRUCT: (state, addBriefnessInstruct) => { state.addBriefnessInstruct = addBriefnessInstruct },
    SET_ADDCOMPLEXINSTRUCT: (state, addComplexInstruct) => { state.addComplexInstruct = addComplexInstruct },
    SET_RETRY: (state, reTry) => { state.reTry = reTry },
    SET_CANCEL: (state, cancel) => { state.cancel = cancel },
    SET_QUERYBYTYPE: (state, queryByType) => { state.queryByType = queryByType },
    SET_EXPORTTERMINALID: (state, exportTerminalId) => { state.exportTerminalId = exportTerminalId },
};

const actions = {
    GET_QUERYINSTRUCTLIST: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            queryInstructList(data)
                .then((res) => {
                    commit("SET_QUERYINSTRUCTLIST", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_ADDBRIEFNESSINSTRUCT: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            addBriefnessInstruct(data)
                .then((res) => {
                    commit("SET_ADDBRIEFNESSINSTRUCT", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_ADDCOMPLEXINSTRUCT: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            addComplexInstruct(data)
                .then((res) => {
                    commit("SET_ADDCOMPLEXINSTRUCT", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_RETRY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            reTry(data)
                .then((res) => {
                    commit("SET_RETRY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_CANCEL: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            cancel(data)
                .then((res) => {
                    commit("SET_CANCEL", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_QUERYBYTYPE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            queryByType(data)
                .then((res) => {
                    commit("SET_QUERYBYTYPE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_EXPORTTERMINALID: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            exportTerminalId(data)
                .then((res) => {
                    commit("SET_EXPORTTERMINALID", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
